import type { CategoryContent } from '../row.js';

/** Beeldende kunst & architectuur, muziek & podiumkunsten, film & televisie. */

export const MUSIC: CategoryContent = {
  msc: [

    [
      'In gecijferd bas geeft een losstaande "6" onder een noot wat aan?',
      [
        'Een akkoord in eerste omkering, met een sext boven de bas in plaats van een kwint',
        'Een sext-kwartakkoord, waarbij zowel de sext als de kwart boven de bas klinken, typisch in een cadentiële formule',
        'Een voorhouding die neerwaarts naar de kwint oplost',
        'De zesde toon van de heersende toonladder als orgelpunt',
      ],
      0,
      'Gecijferde bas op zicht realiseren was een praktische vaardigheid, geen theorieoefening: de "6" vertelt je evenzeer wat je moet weglaten als wat je moet spelen.',
    ],
    [
      'Wat karakteriseert de doorwerking in de sonatevorm?',
      [
        'Fragmentatie en modulatie van het materiaal uit de expositie via onstabiele toonsoorten',
        'De eerste presentatie van het tweede thema in de dominant',
        'Een terugkeer naar de tonica met beide thema\'s hernomen',
        'Een slotgedeelte dat de tonica bevestigt via een reeks herhaalde authentieke cadensen, vaak met een uitgebreide coda',
      ],
      0,
      'De andere drie beschrijven de expositie, de reprise en de coda. Tonale instabiliteit is precies wat de terugkeer als een aankomst laat aanvoelen.',
    ],
    [
      'Wat is een hemiool?',
      [
        'Een ritmische verschuiving waarbij drie tellen de tijd van twee innemen',
        'Een melodische figuur die op de octaaf omkeert',
        'Een cadens waarbij de bas een stap omhoog gaat naar de tonica in plaats van te dalen',
        'Een bourdon die aangehouden wordt onder een bewegende bovenstem',
      ],
      0,
      'Alomtegenwoordig in barokke cadensen in drieledige maat en opnieuw bij Brahms, waar het een structureel middel is en geen versiering.',
    ],
    [
      'Hoe organiseert de ritornelvorm een deel?',
      [
        'Een terugkerend orkestraal refrein dat afwisselt met contrasterende solo-episodes',
        'Eén thema dat continu gevarieerd wordt over een herhaalde bas',
        'Twee thema\'s gepresenteerd, doorgewerkt en hernomen in de tonica',
        'Een fugatische expositie gevolgd door episodes en een slotstretto, waarbij het hoofdthema in engere imitatie terugkeert',
      ],
      0,
      'Het standaardplan van het barokconcerto, en de voorloper van het klassieke rondo - al keert het ritornel doorgaans getransponeerd en verkort terug in plaats van intact.',
    ],
    [
      'Waarnaar verwijst musica ficta?',
      [
        'Voortekens die uitvoerders in oude muziek zelf toevoegen in plaats van dat ze genoteerd staan in de bron',
        'Een notatiestenografie voor herhaalde ritmische patronen',
        'Muziek gecomponeerd voor instrumenten die niet meer bestaan',
        'Een theoretische toonladder die in onderwijs en speculatieve theorie wordt gebruikt maar niet in daadwerkelijke composities',
      ],
      0,
      'Uitgevers twisten er nog altijd over waar het precies hoort, en dat is waarom twee gerenommeerde edities van hetzelfde vijftiende-eeuwse stuk hoorbaar kunnen verschillen.',
    ],
  ],
  phd: [
    [
      'Op welke toonladdertrap wordt een Napolitaanse sext gebouwd?',
      [
        'De verlaagde tweede',
        'De vierde, de grondtoon van de subdominant',
        'De verlaagde zesde, waarop in mineur vaak een sixte ajoutée wordt gebouwd',
        'De leidtoon, een halve toon onder de tonica',
      ],
      0,
      'Een grote drieklank op de verlaagde bovendominant, bijna altijd in eerste omkering, waar de "sext" haar naam aan ontleent.',
    ],
    [
      'Wat onderscheidt een passacaglia van een chaconne?',
      [
        'De passacaglia is meestal gebouwd op een herhaalde baslijn, de chaconne op een herhaalde harmonische progressie',
        'De passacaglia staat altijd in tweedelige maat',
        'De chaconne is een vocale vorm',
        'De chaconne moet in een kleine toonsoort staan, terwijl de passacaglia in beide toonsoorten kan voorkomen. Dit verklaart waarom de twee apart gecatalogiseerd worden in het barokrepertoire',
      ],
      0,
      'Het onderscheid is los en componisten negeerden het, maar dat is wel de gangbare schoolboekindeling.',
    ],
    [
      'Wat is een colotomische structuur in de gamelanmuziek?',
      [
        'Het gongpatroon dat de cyclische vorm markeert',
        'Het stemmingssysteem van de metallofonen, doorgaans slendro of pelog',
        'De relatie tussen de twee gepaarde stemmingen',
        'De geïmproviseerde uitwerking van de kernmelodie',
      ],
      0,
      'Instrumenten zoals de kenong en de kempul markeren onderverdelingen van een gongcyclus; de stemmingen zijn slendro en pelog.',
    ],
    [
      'Wat vereist Arnold Schönbergs twaalftoonsmethode van een reeks?',
      [
        'Alle twaalf toonhoogteklassen komen voor voordat er herhalingen optreden',
        'De reeks moet palindromisch zijn',
        'De reeks moet reine kwinten vermijden',
        'De reeks moet beginnen en eindigen op dezelfde toon, wat de indruk van tonale afsluiting geeft',
      ],
      0,
      'De volgorde wordt daarna onderworpen aan omkering, retrograde en retrograde omkering, plus transpositie.',
    ],
    [
      'Welke toonsoort heeft de kenmerkende verhoogde vierde trap?',
      ['Dorisch', 'Frygisch', 'Lydisch', 'Aeolisch'],
      2,
      'Lydisch is een grote toonladder met een verhoogde vierde. Dorisch verhoogt de zesde ten opzichte van de natuurlijke kleine toonladder.',
    ],
  ],
  professor: [
    [
      'Wat is hocket in de middeleeuwse polyfonie?',
      [
        'Een melodie verdeeld over stemmen in snelle afwisseling',
        'Een bourdon die onder een bewegende lijn wordt aangehouden',
        'Een canon op de unisono',
        'Een cadensversiering toegepast op de voorlaatste noot van een frase',
      ],
      0,
      'Rusten worden vervlochten zodat de lijn gedeeld wordt tussen stemmen - kenmerkend voor de Ars Nova en voor bepaalde Centraal-Afrikaanse praktijken.',
    ],
    [
      'Wat is de Ursatz in de Schenkeriaanse analyse?',
      [
        'De fundamentele structuur van een dalende melodische lijn over een basarpeggiatie',
        'Het openingsmotief waaruit alle andere afgeleid zijn',
        'De oorspronkelijke genoteerde tekst zoals de componist die achterliet, vóór latere redactionele wijzigingen',
        'De onderliggende ritmische cel van een deel',
      ],
      0,
      'De Urlinie daalt naar de tonica over een I-V-I-basarpeggiatie; al het andere is een prolongatie ervan.',
    ],
    [
      'Welk interval verdeelt de Bohlen-Pierce-toonladder?',
      ['De octaaf', 'De tritave (een reine twaalfde)', 'De reine kwint', 'De dubbele octaaf, een verhouding van vier op één'],
      1,
      'Dertien stappen binnen een frequentieverhouding van 3:1, gebouwd voor klanken waarvan de boventonen oneven genummerd zijn.',
    ],
    [
      'Welke term beschrijft een renaissancemis volledig gebaseerd op een voorgaande polyfone compositie?',
      ['Cantus-firmusmis', 'Parodiemis', 'Parafrasemis', 'Canonieke mis'],
      1,
      'Ook wel imitatiemis genoemd. Een cantus-firmusmis leent slechts één lijn; een parafrasemis werkt een monofone bron uit.',
    ],
    [
      'Wat is de vadi van een raga in de Hindoestaanse klassieke muziek?',
      [
        'De meest prominente toon',
        'De ritmische cyclus',
        'Het geïmproviseerde openingsgedeelte',
        'De opgaande toonhoogtereeks',
      ],
      0,
      'De vadi domineert en de samvadi beantwoordt hem; de cyclus is de tala, het openingsgedeelte de alap, de opgang de aroha.',
    ],
  ],
  bscba: [
    [
      'Wat is een toonladder in muziek?',
      [
        'Een geordende reeks tonen die op- of neerwaarts stijgen in stappen',
        'Een reeks variaties op een enkel melodisch thema',
        'De relatieve luidheid van een muzikale passage',
        'De snelheid waarmee een stuk wordt uitgevoerd',
      ],
      0,
      'De grote toonladder en de natuurlijke kleine toonladder komen het meest voor in de westerse muziek, met zeven tonen plus de octaaf.',
    ],
    [
      'Wat is harmonie in muziek?',
      [
        'Het gelijktijdig klinken van meerdere noten',
        'Het herhalend patroon van sterke en zwakke tellen',
        'De algehele vorm en contour van een melodie',
        'De ritmische onderverdeling van muzikale tijd',
      ],
      0,
      'Harmonie ontstaat wanneer noten met verschillende toonhoogten tegelijk klinken, gezongen of door verschillende instrumenten gespeeld.',
    ],
    [
      'Wat is een cadens in muziek?',
      [
        'Een slotprogressie van akkoorden die een frase of stuk afsluit',
        'Een aangehouden noot over een akkoordverandering heen',
        'Een snelle versiering van een enkele noot',
        'Het openingsthema van een deel',
      ],
      0,
      'Authentieke cadens (V-I) en plagale cadens (IV-I) zijn de meest voorkomende. Ze geven harmonische afsluiting.',
    ],
    [
      'Wat is een fuga?',
      [
        'Een polyfone compositie met meerdere onafhankelijke melodische lijnen',
        'Een snel, energiek gedeelte van een groter werk',
        'Een dramatische verandering in dynamica binnen een stuk',
        'Een techniek om het tempo geleidelijk te vertragen',
      ],
      0,
      'Een thema wordt geïntroduceerd in één stem en nagevolgd in de andere stemmen, waardoor complex contrapunt ontstaat.',
    ],
    [
      'Orkestrinstrumenten worden traditioneel verdeeld in hoeveel families?',
      [
        'Vier: snaarinstrumenten, houtblazers, koperblazers en slagwerk',
        'Vijf: toetsinstrumenten als aparte familie toevoegend',
        'Drie: melodie, harmonie en ritme',
        'Zeven: historische klasseringen toevoegend',
      ],
      0,
      'Dit westerse systeem groepeert instrumenten per productiewijze. Elke familie beslaat een duidelijk register.',
    ],
    [
      'Wat is timbre in muziek?',
      [
        'De karakteristieke kwaliteit of kleur van een geluid van een instrument of stem',
        'De relatieve toonhoogte tussen twee noten',
        'De trillingsnelheid van een geluidsgolf',
        'De duur van een enkele muzikale noot',
      ],
      0,
      'Timbre is waarom een viool en een trompet anders klinken op dezelfde noot. Het hangt af van de boventonen en de productiewijze.',
    ],
    [
      'Een akkoord gebouwd op drie noten wordt genoemd:',
      [
        'Een drieklank',
        'Een tweeklank',
        'Een septimakkoord',
        'Een suspensieakkoord',
      ],
      0,
      'Een drieklank heeft drie toonhoogten gestapeld in tertsen. Grote en kleine drieklanken zijn fundamentele harmonische eenheden.',
    ],
    [
      'Wat is polyfonie in muziek?',
      [
        'Twee of meer onafhankelijke melodische lijnen die gelijktijdig worden gehoord',
        'Een enkele melodie met instrumentale begeleiding',
        'Het samensmelten van gelijkaardige instrumenten in unisono',
        'De herhaling van een muzikale frase',
      ],
      0,
      'Elke stem heeft zijn eigen melodie, die combineert met de andere stemmen om een complexe textuur en harmonie te creëren.',
    ],
    [
      'De Barokperiode in de westerse muziek omvat grofweg welke eeuw?',
      [
        'De 17e eeuw en vroege 18e eeuw',
        'De 15e en 16e eeuw',
        'De 19e eeuw',
        'De 20e eeuw',
      ],
      0,
      'Barokmuziek (grofweg 1600-1750) kende sierlijke melodie, harmonische vernieuwing en vormen als het concerto.',
    ],
    [
      'Wat is een sonatevorm?',
      [
        'Een muzikale structuur met expositie, doorwerking en reprise',
        'Een stuk geschreven voor een soloinstrument met begeleiding',
        'Een langzaam lyrisch deel in een groter werk',
        'Een thema met een bepaald aantal variaties',
      ],
      0,
      'De sonatevorm vormt de basis van het eerste deel van een symfonie of concerto. Drama ontstaat uit contrasterende thema\'s.',
    ],
    [
      'Een verminderd akkoord is gebouwd op welk interval?',
      [
        'Gestapelde kleine tertsen',
        'Gestapelde grote tertsen',
        'Reine kwinten',
        'Grote seconden',
      ],
      0,
      'Drie noten gescheiden door kleine tertsen vormen een verminderde drieklank. Die klinkt gespannen en onstabiel en lost op.',
    ],
    [
      'De Renaissanceperiode in muziek omvat grofweg welke eeuwen?',
      [
        'De 15e en 16e eeuw',
        'De 17e en 18e eeuw',
        'De 13e en 14e eeuw',
        'De 19e en 20e eeuw',
      ],
      0,
      'Renaissancemuziek (ca. 1400-1600) verschoof geleidelijk van middeleeuwse modi naar moderne groot- en kleine toonladders.',
    ],
    [
      'Wat is een interval in muziek?',
      [
        'De toonhoogteafstand tussen twee noten',
        'De ruimte tussen twee lijnen op een notenbalk',
        'Een pauze of rust tijdens een uitvoering',
        'De maatsoort van een stuk',
      ],
      0,
      'Intervallen worden benoemd door stappen te tellen: een terts omvat drie letters, een kwint vijf. Ze zijn de bouwstenen van melodie.',
    ],
    [
      'Wat is contrapunt?',
      [
        'De kunst om onafhankelijke melodische lijnen te combineren',
        'De begeleiding onder een hoofdmelodie',
        'De geleidelijke verdunning van muzikale textuur',
        'Het gebruik van herhaalde ritmische patronen',
      ],
      0,
      'Elke lijn is muzikaal onafhankelijk maar combineert logisch. Bach is de meester van deze techniek.',
    ],
    [
      'Wat is een rondevorm?',
      [
        'Een structuur waarin een hoofdthema afwisselt met contrasterende secties',
        'Een langzame introductie gevolgd door een snel deel',
        'Een thema gevolgd door een reeks variaties',
        'Een stuk dat door verschillende toonsoorten moduleert',
      ],
      0,
      'Rondevorm (ABACA...) gebruikt een memorabel hoofdthema dat blijft terugkeren. Deze vorm komt veel voor in finales van concerto\'s.',
    ],
  ],
};

export const SCREEN: CategoryContent = {
  msc: [

    [
      'Waar verwijst de term decoupage in de Franse filmkritiek naar?',
      [
        'De opdeling van een scène in shots, vastgelegd vóór het filmen',
        'De uiteindelijke samenstelling van shots in de montagekamer, na afronding van de opnames',
        'Het lichtplan voor een set, afgeleid van het draaiboek',
        'De compositie van elementen binnen één enkel beeld',
      ],
      0,
      'Decoupage is het plan; montage is de samenstelling. Het onderscheid is belangrijk omdat het het auteurschap vóór in plaats van na de opname plaatst.',
    ],
    [
      'Welke beeldverhouding heeft de Academy-ratio?',
      ['1,37:1', '1,85:1', '2,35:1', '1,66:1'],
      0,
      'Gestandaardiseerd in 1932 voor geluidsfilm. 1,85 en 2,35 zijn de breedbeeldreacties op televisie twee decennia later.',
    ],
    [
      'Door wie werd Ladri di biciclette geregisseerd?',
      [
        'Vittorio De Sica',
        'Roberto Rossellini, wiens Roma, città aperta drie jaar eerder uitkwam',
        'Luchino Visconti, wiens La terra trema in hetzelfde jaar uitkwam',
        'Federico Fellini, destijds werkzaam als scenarioschrijver binnen de beweging',
      ],
      0,
      'De Sica regisseerde Ladri di biciclette in 1948, met een cast die grotendeels uit niet-professionals bestond, in neorealistische traditie. Fellini schreef mee aan het scenario.',
    ],
    [
      'Wat betekent diëgetisch geluid?',
      [
        'Geluid waarvan de bron zich binnen de verhaalwereld bevindt',
        'Geluid dat synchroon met het beeld op locatie is opgenomen',
        'Geluid dat in de postproductie is toegevoegd om onbruikbare locatiegeluid te vervangen',
        'Geluid dat het publiek hoort maar geen enkel personage',
      ],
      0,
      'Een radio die een personage aanzet is diëgetisch; de score meestal niet. De interessante gevallen zijn die waarin de grens opzettelijk overschreden wordt.',
    ],
    [
      'Wat probeert continuïteitsmontage vooral te verbergen?',
      [
        'De snede zelf, zodat ruimtelijke en tijdelijke relaties ongebroken aanvoelen',
        'De aanwezigheid van de filmploeg in reflecterende oppervlakken van een set, zoals ramen of spiegels',
        'De compressie van verhaaltijd tot schermtijd',
        'Het gebruik van doubles en stand-ins voor de hoofdrolspelers',
      ],
      0,
      'Blikwisselmatches, de 180-gradenregel en de match-on-action dienen allemaal hetzelfde doel: een samengestelde ruimte laten aanvoelen als een ononderbroken ruimte.',
    ],
  ],
  phd: [
    [
      'Wat toont het Kulesjov-effect aan?',
      [
        'Dat betekenis ontstaat uit de juxtapositie van shots eerder dan uit hun inhoud',
        'Dat camerabeweging bepaalt met welk personage het publiek uiteindelijk meeleeft',
        'Dat kleurtemperatuur de waargenomen duur beïnvloedt',
        'Dat geluid de visuele continuïteit kan overstemmen',
      ],
      0,
      'Eenzelfde shot van een gezicht wordt gelezen als verdriet of verlangen, afhankelijk van het shot waarmee het gemonteerd wordt.',
    ],
    [
      'Wat is een dutch angle?',
      ['Een gekantelde camera', 'Een extreem groothoeklens', 'Een shot door een deuropening', 'Een omgekeerde travellingopname'],
      0,
      'Het beeld staat scheef ten opzichte van de horizon. Heeft niets met Nederland te maken - de term komt van Deutsch.',
    ],
    [
      'Welke regisseur wordt geassocieerd met het begrip "poëtische cinema" uit een essay van 1965?',
      ['Pier Paolo Pasolini', 'Michelangelo Antonioni', 'Jean-Luc Godard', 'Andrei Tarkovski'],
      0,
      'Pasolini pleitte voor een vrije indirecte subjectiviteit, waarbij de camera de manier van kijken van een personage overneemt zonder het personage te ventriloquiseren.',
    ],
    [
      'Wat regelt de 180-gradenregel in klassieke Hollywood-continuïteitsmontage?',
      [
        'Het houden van de camera aan één kant van de as tussen twee subjecten',
        'De maximaal toegestane duur van een snede',
        'De vereiste hoekverandering tussen opeenvolgende shots',
        'De richting van schermbeweging over een snede heen',
      ],
      0,
      'De as oversteken verwisselt links en rechts en desoriënteert de kijker. De 30-gradenregel regelt de hoekverandering.',
    ],
    [
      'Welke filmbeweging vaardigde het Dogme 95-manifest uit?',
      ['De Franse nouvelle vague', 'Een Deens collectief onder leiding van Lars von Trier en Thomas Vinterberg', 'De nieuwe Duitse film', 'De Tsjechische nieuwe golf van de Barrandov-studiogeneratie'],
      1,
      'Tien "kuisheidsgeloften": opname op locatie, geen non-diëgetische muziek, geen credits voor de regisseur, onder andere.',
    ],
  ],
  professor: [
    [
      'Wat betoogt André Bazin over diepte-scherpte in zijn geschriften over realisme?',
      [
        'Het bewaart de ambiguïteit van het werkelijke door de kijker vrij te laten kiezen waar hij kijkt',
        'Het versterkt de montage door meer informatie per shot toe te voegen',
        'Het maakt de ruimte plat en abstraheert zo het beeld',
        'Het is een technische beperking van het lensontwerp eerder dan een bewuste esthetische keuze van de regisseur',
      ],
      0,
      'Bazin plaatste dit tegenover de Sovjetmontage: compositie in de diepte respecteert de ruimtelijke continuïteit en legt de interpretatie bij de toeschouwer.',
    ],
    [
      'Waarnaar verwijst de term "phantom ride" in de vroege cinema?',
      [
        'Een film opgenomen vanaf de voorkant van een rijdend voertuig',
        'Een dubbele belichting die een spookfiguur oplevert',
        'Een projectie met twee gesynchroniseerde machines',
        'Een reizende filmvertoning op kermissen',
      ],
      0,
      'Populair vanaf de late jaren 1890, meestal opgenomen vanaf de koeienvanger van een trein.',
    ],
    [
      'Wat bedoelde Eisenstein met "intellectuele montage" in de Sovjet-montagetheorie?',
      [
        'Montage die een abstract concept oplevert eerder dan een ruimtelijke of emotionele relatie',
        'Montage strikt gestuurd door het ritme van de muzikale begeleiding op de uiteindelijke soundtrack',
        'Documentairebeeld samenvoegen tot een betoog',
        'Grafische vormen over een snede heen laten overeenkomen',
      ],
      0,
      'De slachthuismontage in Bezsjenka (Strike) is het standaardvoorbeeld: twee concrete beelden leveren een derde, abstracte term op.',
    ],
    [
      'Wat is de "acousmêtre" in Michel Chions theorie van filmgeluid?',
      [
        'Een stem die gehoord maar niet gezien wordt, en macht behoudt totdat ze gelokaliseerd wordt',
        'De waargenomen ruimtelijke omvang van een opgenomen geluid',
        'Het synchronisatiepunt tussen beeld en geluid',
        'De restruis van de opnameapparatuur die onder de opname hoorbaar is',
      ],
      0,
      'De moederstem in Psycho, of Mabuse. Chion betoogt dat ze haar macht verliest op het moment dat ze een lichaam krijgt.',
    ],
    [
      'Welke nationale cinema bracht de "gouden eeuw"-melodrama voort van de jaren 1940 en 1950, geassocieerd met Emilio Fernández en cameraman Gabriel Figueroa?',
      ['Argentinië', 'Mexico', 'Brazilië', 'Egypte'],
      1,
      'Mexico. Figueroa\'s diepgefilterde luchten en lage horizonnen werden het visuele handelsmerk van die periode.',
    ],
  ],
  bscba: [
    [
      'Wat is een filmopname?',
      [
        'Een enkele continue opname van één camerapositie tot de camera stopt',
        'Een afzonderlijk fotografisch frame uit een filmreeks',
        'De hele sequentie van begin tot einde van een scène',
        'De uiteindelijke gemonteerde versie van een film in de bioscoop',
      ],
      0,
      'Een opname is de fundamentele bouwsteen van filmmontage. Meerdere opnames worden gecombineerd om scènes te creëren.',
    ],
    [
      'Waarnaar verwijst de term montage in film?',
      [
        'Het assembleren en sequencen van opnames in het bewerkingsproces',
        'Een droomsequentie afgebeeld via wazig beeld',
        'De overbelichting van meerdere beelden op één frame',
        'Een snelle reeks niet-gerelateerde beelden die het verstrijken van tijd tonen',
      ],
      0,
      'Montage is de kunst van filmeditie - hoe opnames gecombineerd worden om betekenis te creëren. De term komt uit het Frans.',
    ],
    [
      'Wat is de beeldverhouding van een film?',
      [
        'De verhouding van breedte tot hoogte van het geprojecteerde beeld',
        'De framesnelheid gemeten in frames per seconde',
        'De lengte van een opname gemeten in seconden',
        'De hoek waaronder de camera gepositioneerd is',
      ],
      0,
      'Standaardverhoudingen zijn 1,37:1 (Academy), 1,85:1 (breedbeeld) en 2,35:1 (anamorf breedbeeld).',
    ],
    [
      'Wat is de establishing shot in film?',
      [
        'Een initieel breed shot dat de locatie van een scène toont',
        'Een close-up van het gezicht van een personage aan het begin van een scène',
        'De opname die een sequentie afsluit',
        'Een opname van een hoge hoek neerwaarts kijkend',
      ],
      0,
      'De establishing shot oriënteert het publiek ruimtelijk. Na deze brede weergave kan de regisseur snijden naar nauwere opnames.',
    ],
    [
      'Waarnaar verwijst de 180-gradenregel in filmproductie?',
      [
        'Camera aan één kant van een denkbeeldige as tussen personages houden',
        'De maximale afstand tussen camera en subject',
        'De camera 180 graden draaien voor een omgekeerde opname',
        'De hoek van de zon voor buiten filmen',
      ],
      0,
      'De as oversteken verwisselt links en rechts, wat het publiek desoriënteert. Dit handhaaft de ruimtelijke consistentie tussen sneden.',
    ],
    [
      'Wat is een close-up shot?',
      [
        'Een opname die een onderwerp strak inkadert, meestal het gezicht of een klein object',
        'Een opname dicht bij de actie maar volledig figuren tonend',
        'Een opname van ver weg met een breed landschap',
        'Een opname van extreem neerwaarts',
      ],
      0,
      'Close-ups concentreren emotionele aandacht op een personage of object. Ze zijn essentieel voor het overbrengen van subtiele uitdrukkingen.',
    ],
    [
      'Filmmontage die de illusie van continue ruimte en tijd handhaaft heet:',
      [
        'Continuïteitsmontage',
        'Jump-cut montage',
        'Montagesequencemontage',
        'Snijdend tussen acties',
      ],
      0,
      'Continuïteitsmontage gebruikt blikwisselmatches, match-on-action en de 180-gradenregel voor een naadloze verbinding.',
    ],
    [
      'Wat is een pan-shot in cinematografie?',
      [
        'Een camerabeweging die horizontaal van links naar rechts of omgekeerd roteert',
        'Een opname van de volledige set of landschap',
        'Een snelle snede van de ene locatie naar de andere',
        'Een opname waarin de camera naar het onderwerp beweegt',
      ],
      0,
      'Een pan volgt beweging of onthult informatie. Dit verschilt van een traveling shot, die door de ruimte beweegt.',
    ],
    [
      'Wat is het verschil tussen een close-up en een extreme close-up?',
      [
        'Een extreme close-up kadert een nog kleiner gebied in, met minder context',
        'Close-up wordt gebruikt voor dialogen en extreme close-up voor actie',
        'Extreme close-up toont volledige lichaam terwijl close-up gezicht toont',
        'Er is geen technisch verschil; termen worden door elkaar gebruikt',
      ],
      0,
      'Extreme close-ups kaderen alleen de ogen of lippen in, wat de gezichtscontext elimineert. Ze creëren intensiteit.',
    ],
    [
      'Wat is scherptediepte in cinematografie?',
      [
        'Het afstandsbereik waarbinnen het beeld scherp lijkt',
        'De afstand tussen camera en onderwerp',
        'De kijkhoek opgenomen door cameralens',
        'De duur dat een opname op het scherm blijft',
      ],
      0,
      'Ondiepe scherptediepte houdt het onderwerp scherp met een wazige achtergrond. Diepe scherptediepte houdt een groter deel van de scène scherp.',
    ],
    [
      'Wat is een overlay of superimpositie in film?',
      [
        'Twee beelden tegelijk op het scherm, waarvan een gedeeltelijk transparant is',
        'Een stem gehoord terwijl beelden uit een ander moment getoond worden',
        'Eén beeld vervangen door een ander via geleidelijke overgang',
        'Tekst of graphics toegevoegd aan beeld',
      ],
      0,
      'Overlays tonen gelijktijdige gebeurtenissen of herinneringen. Spookfiguren en dubbele belichtingen zijn traditionele technieken.',
    ],
    [
      'Cinematografie verwijst naar welk aspect van filmproductie?',
      [
        'De kunst en techniek van het vastleggen van beelden op film of digitale media',
        'Het schrijven van dialogen en verhaalstructuur',
        'Het arrangement en de beweging van acteurs op set',
        'De editie en samenvoging van opnames',
      ],
      0,
      'Cinematografie omvat verlichting, camerabeweging en lenskeuze. De cameraman is de directeur fotografie.',
    ],
    [
      'Wat is een dolly shot?',
      [
        'Een opname waarin de camera fysiek naar het onderwerp toe of weg beweegt',
        'Een opname van een hoog uitzichtpunt boven de scène',
        'Een snelle snede tussen verschillende kamerahoeken',
        'Een opname waarin de camera op een vaste as roteert',
      ],
      0,
      'Een dolly is een op wielen staande kar waarop de camera staat. Dolly shots creëren een gevoel van beweging en trekken de kijker de ruimte in of uit.',
    ],
    [
      'Wat is film noir?',
      [
        'Een genre van misdaadfilms met donker, schaduwrijk licht en cynische personages',
        'Een soort historisch drama in Europese steden gesitueerd',
        'Een komedie met lichamelijke humor en slapstick',
        'Een abstracte experimentele filmbeweging',
      ],
      0,
      'Film noir ontstond in de jaren veertig en vijftig, met contrastrijke zwart-witcinematografie en moreel dubieuze protagonisten.',
    ],
    [
      'Wat is een reaction shot?',
      [
        'Een close-up van de emotionele reactie van een personage op iets wat gezegd of gezien wordt',
        'Een opname van de volledige actie van begin tot eind',
        'Een camerabeweging die over de hele scène pant',
        'Een overhead shot die lay-out van locatie toont',
      ],
      0,
      'Reaction shots tonen de reactie van de luisteraar op iets. Ze zijn essentieel voor het opbouwen van emotionele verbinding.',
    ],
  ],
};
